const getListQuery = (payload: any) => {
    try {
        let query = `
        `;
        return query;
    } catch (ex) {
    }
}

const createCustomerQuery = (payload: any) => {

    try {
        let query = `
        mutation {
            saveCustomer(input: {
                customerDetailId: ${payload?.customerId ? `"${payload?.customerId}"` : null},
                customerName: "${payload?.customerName}",
                mobileNumber: "${payload?.mobileNumber}",
                dateOfBirth: ${payload?.dateOfBirth ? `"${payload?.dateOfBirth}"` : null},
                weddingAnniversary: ${payload?.weddingAnniversary ? `"${payload?.weddingAnniversary}"` : null},
                whatsappGroupStatus: ${payload?.whatsappGroupStatus ?? 0},
                isNotWhatsappNumber: ${payload?.isNotWhatsappNumber ?? 0}
            })
        }
        `;
        return query;
    } catch (ex) {
    }
}

const mergeCustomerQuery = (payload: any) => {
    try {
        let query = `
        mutation {
            mergeCustomer(input: {
                sourceCustomerId: "${payload?.sourceCustomerId || ''}",
                targetCustomerId: "${payload?.targetCustomerId || ''}"
            })
        }
        `;
        return query;
    } catch (ex) {
    }
}

const setCustomerCreditLimitQuery = (payload: any) => {
    try {
        let query = `
        mutation {
            setCustomerCreditLimit(input: {
                customerId: "${payload?.customerId || ''}",
                creditLimit: ${Number(payload?.creditLimit) || 0}
            })
        }
        `;
        return query;
    } catch (ex) {
    }
}

const addCustomerCreditOpeningBalanceQuery = (payload: any) => {
    try {
        let query = `
        mutation {
            addCustomerCreditOpeningBalance(input: {
                customerId: "${payload?.customerId || ''}",
                amount: ${Number(payload?.amount) || 0},
                remarks: ${payload?.remarks ? `"${payload?.remarks}"` : null},
                transactionDate: ${payload?.transactionDate ? `"${payload?.transactionDate}"` : null}
            })
        }
        `;
        return query;
    } catch (ex) {
    }
}

const recordCustomerCreditSettlementQuery = (payload: any) => {
    try {
        let query = `
        mutation {
            recordCustomerCreditSettlement(input: {
                customerId: "${payload?.customerId || ''}",
                amount: ${Number(payload?.amount) || 0},
                paymentMethodRefId: ${payload?.paymentMethodRefId ?? null},
                remarks: ${payload?.remarks ? `"${payload?.remarks}"` : null},
                transactionDate: ${payload?.transactionDate ? `"${payload?.transactionDate}"` : null}
            })
        }
        `;
        return query;
    } catch (ex) {
    }
}

const getCustomerCreditLedgerQuery = (payload: any) => {
    try {
        let query = `
        query {
            getCustomerCreditLedger(input: {
                customerId: "${payload?.customerId || ''}",
                direction: ${payload?.direction ? `"${payload?.direction}"` : null},
                creditLedgerId: ${payload?.creditLedgerId ? `"${payload?.creditLedgerId}"` : null},
                paging: {
                    limit: ${payload?.limit},
                    offset: ${payload?.offset}
                }
            })
        }
        `;
        return query;
    } catch (ex) {
    }
}

const updateProductItemColorOrSizeQuery = (payload: any) => {
    try {
        let query = `
        mutation {
            updateColorOrSize(
               productItemId: "${payload?.productItemId}",
               colorRefId: ${payload?.colorRefId},
               sizeRefId: ${payload?.sizeRefId})
        }
        `;
        return query;
    } catch (ex) {
    }
}

const addProductQuery = (payload: any) => {
    try {
        // Notes is free-form text (quotes/newlines likely) — escape it before
        // interpolating into the query string, unlike the other string fields here.
        const escapedDescription = (payload?.description ?? "").replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\n/g, "\\n");
        // Combo stock: component lines are only sent on create (the API
        // ignores them on edit — a combo's items are locked once created).
        const comboItems = Array.isArray(payload?.comboItems) && payload.comboItems.length
            ? `comboItems: [${payload.comboItems
                .map((c: any) => `{ productDetailId: ${JSON.stringify(String(c?.productDetailId ?? ""))}, quantity: ${parseInt(c?.quantity) || 0} }`)
                .join(", ")}]`
            : "";
        let query = `
        mutation {
            createProduct_v2(input: {
                salesType: ${payload?.salesType},
                core_category: ${payload?.coreCategoryId}
                productDetailId: "${payload?.productDetailId}"
                categoryId: "${payload?.categoryId}"
                subCategoryId: "${payload?.subCategoryId}"
                productName: "${payload?.productName}"
                mrp: ${payload?.mrp}
                minimumQuantity: ${payload?.minimumQuantity}
                weight: ${payload?.weight ? payload?.weight :0}
                isMultipleRecords: ${payload?.isMultipleRecords}
                sizeRefId: ${payload?.size}
                colorRefId: ${payload?.color}
                vendorId: "${payload?.vendorId}"
                purchaseDate:"${payload?.purchaseDate}"
                description: "${escapedDescription}"
                stockType: ${payload?.stockType ?? 1}
                ${comboItems}
            })
        }
        `;
        return query;
    } catch (ex) {
    }
}

const getCategoryQuery = (payload: any) => {
    try {
        let query = `
        query {
            getCategoryList(input:{
            isCategoryPage :${payload?.isCategoryPage ? payload?.isCategoryPage : 0}
            })
        }
        `;
        return query;
    } catch (ex) {
    }
}

const updateProductStatusQuery = (payload: any) => {
    try {
        let productId = JSON.stringify(payload?.productItemId).replace(/"([^(")"]+)":/g, "$1:")

        let query = `
        mutation {
            updateProductItemStatus(
                productItemId: ${productId},
                isArray:${payload?.isArray},
                statusRefId: ${payload?.statusRefId},
                status: "${payload?.status}"
            )
        }
        `;
        return query;
    } catch (ex) {
    }
}

const updateStickeringStatusQuery = (payload: any) => {
    try {
        let query = `
        mutation {
            updateStickeringStatus(
                productItemId: "${payload?.productItemId}"
            )
        }
        `;
        return query;
    } catch (ex) {
    }
}

const getProductListQuery = (payload: any) => {
    let statusRefId = JSON.stringify(payload?.statusRefId).replace(/"([^(")"]+)":/g, "$1:")
    let statusType = typeof payload?.statusRefId

    try {
        let query = `
        query {
            getProductList(input:{
                searchText: "${payload?.searchText}"
                statusRefId: ${payload?.statusRefId == "1,2,4,5,6" ? statusRefId : payload?.statusRefId != "1" ? `"${payload?.statusRefId}"` : null}
                mrp: ${payload?.mrp ? payload?.mrp : null}
                vendorId: ${payload?.vendorId ? `"${payload.vendorId}"` : null}
                categoryId: ${payload?.categoryId ? `"${payload.categoryId}"` : null}
                subCategoryId: ${payload?.subCategoryId ? `"${payload.subCategoryId}"` : null}
                stockType: ${payload?.stockType ? payload.stockType : null}
                paging:{
                    limit:${payload?.limit},
                    offset:${payload?.offset}
                }
            })
        }
        `;
        return query;
    } catch (ex) {
    }
}

const getCustomerListQuery = (payload: any) => {
    try {
        let query = `
        query {
            getCustomerList(input:{
                searchText: "${payload?.searchText}"
                sortBy:${payload?.sortBy}
                whatsappGroupStatus: ${payload?.whatsappGroupStatus === 0 || payload?.whatsappGroupStatus === 1 ? payload.whatsappGroupStatus : null}
                isNotWhatsappNumber: ${payload?.isNotWhatsappNumber === 0 || payload?.isNotWhatsappNumber === 1 ? payload.isNotWhatsappNumber : null}
                hasOutstanding: ${payload?.hasOutstanding ? true : null}
                paging:{
                    limit: ${payload?.limit},
                    offset: ${payload?.offset}
                }
            })
        }
        `;
        return query;
    } catch (ex) {
    }
}

const getUpcomingCustomerEventsQuery = (payload: any) => {
    try {
        let limit = payload?.limit ?? 10;
        let query = `
        query {
            getUpcomingCustomerEvents(limit: ${limit})
        }
        `;
        return query;
    } catch (ex) {
    }
}

const getReferenceDataQuery = (payload: any) => {
    try {
        let query = `
        query {
            getReferenceData(
                referenceGroupId: ${payload?.referenceGroupId}
            ){
                id
                name
                description
                sortOrder
                referenceGroupId
            }
        }
        `;
        return query;
    } catch (ex) {
    }
}

const getProductItemQuery = (payload: any) => {
    try {
        let query = `
        query {
            getProductItem(input: {
                productId: "${payload?.productId}"
                isScanned: ${payload?.isScanned}
            }
        )
        }
        `;
        return query;
    } catch (ex) {
    }
}

const createBillQuery = (payload: any) => {
    const productArr = JSON.stringify(payload?.productItemId);
    const product = productArr.replace(/"([^(")"]+)":/g, "$1:");

    try {
        let query = `
        mutation {
            createBilling(input: {
                billTypeRefId: ${payload?.billTypeId}
                customerName: "${payload?.customerName}"
                mobileNumber: "${payload?.mobileNumber}"
                paymentMethodRefId: ${payload?.paymentMethodRefId}
                purchaseDate: "${payload?.purchaseDate}"
                productItems:${product}
                amount: ${payload?.amount}
                gst: ${payload?.gst}
                discount: ${payload?.discount}
                roundOff: ${payload?.roundOff}
                totalAmount: ${payload?.totalAmount}
            })
        }
        `;
        return query;
    } catch (ex) {
    }
}

const createBillQuery_V2 = (payload: any) => {
    const productArr = JSON.stringify(payload?.productItemId);
    const product = productArr.replace(/"([^(")"]+)":/g, "$1:");
    const employeeId = payload?.billedByEmployeeId ? `billedByEmployeeId: "${payload.billedByEmployeeId}"` : '';
    const customerId = payload?.customerId ? `customerId: "${payload.customerId}"` : '';

    try {
        let query = `
        mutation {
            createBilling_v2(input: {
                billingId : "${payload?.billingId}"
                ${customerId}
                billTypeRefId: ${payload?.billTypeId}
                customerName: "${payload?.customerName}"
                mobileNumber: "${payload?.mobileNumber}"
                paymentMethodRefId: ${payload?.paymentMethodRefId}
                purchaseDate: "${payload?.purchaseDate}"
                productItems:${product}
                amount: ${payload?.amount}
                gst: ${payload?.gst}
                discount: ${payload?.discount}
                roundOff: ${payload?.roundOff}
                totalAmount: ${payload?.totalAmount}
                ${employeeId}
            })
        }
        `;
        return query;
    } catch (ex) {
    }
}

const getBillingListQuery = (payload: any) => {
    try {
        let query = `
        query {
            getBillingList(input: {
                searchText: "${payload?.searchText}"
                paymentFilter: "${payload?.paymentFilter || ''}"
                paging:{
                    limit:${payload?.limit},
                    offset:${payload?.offset}
                }
            })
        }
        `;
        return query;
    } catch (ex) {
    }
}

const apparelLoginQuery = (payload: any) => {
    try {
        let query = `
        query {
            login(
                credential:"${payload?.credential}"
            )
        }
        `;
        return query;
    } catch (ex) {
    }
}

// Email + OTP login — replaces email/password as the primary login flow
// (password login kept commented in apparelLogin.tsx / apparel-api's
// loginResolver.ts for rollback). requestLoginOtp triggers the mail; the
// backend owns generation + the 5-minute expiry (apparel-api OtpService).
const sendLoginOtpQuery = (payload: any) => {
    try {
        let query = `
        mutation {
            requestLoginOtp(
                email:"${payload?.email}"
            )
        }
        `;
        return query;
    } catch (ex) {
    }
}

// Aliased to "login" so the response shape (and the existing success-handling
// in apparelReducer, which reads action.result.login) is identical to the
// password flow's result — no branching needed downstream.
const verifyLoginOtpQuery = (payload: any) => {
    try {
        let query = `
        query {
            login: verifyLoginOtp(
                email:"${payload?.email}"
                otp:"${payload?.otp}"
            )
        }
        `;
        return query;
    } catch (ex) {
    }
}

const getCustomerHistoryQuery = (payload: any) => {
    try {
        let query = `
        query {
            getCustomerHistory(input: {
                customerId: "${payload?.customerId}"
            })
        }
        `;
        return query;
    } catch (ex) {
    }
}

const getEmployeeSalesHistoryQuery = (payload: any) => {
    try {
        let monthStr = payload?.month ? `, month: "${payload?.month}"` : '';
        let yearStr = payload?.financialYear ? `, financialYear: ${payload?.financialYear}` : '';
        let limitStr = payload?.limit ? `, limit: ${payload?.limit}` : '';
        let offsetStr = payload?.offset !== undefined ? `, offset: ${payload?.offset}` : '';
        let query = `
        query {
            getEmployeeSalesHistory(input: {
                employeeId: "${payload?.employeeId}"${monthStr}${yearStr}${limitStr}${offsetStr}
            })
        }
        `;
        return query;
    } catch (ex) {
    }
}

const getProductHistoryQuery = (payload: any) => {
    try {
        let query = `
        query{
            getProductHsitory(
                productItemId:"${payload?.productItemId}"
            )
        }
        `;
        return query;
    } catch (ex) {
    }
}

const getInvoiceDetailsQuery = (payload: any) => {
    try {
        let query = `
        query {
            getInvoiceDetails(
                invoiceId: "${payload?.invoiceId}"
            )
        }
        `;
        return query;
    } catch (ex) {
    }
}

const updateMultipleInventoryQuery = (payload: any) => {
    try {
        let query = `
        mutation {
            updateMultipleInventory(input: {
                productDetailId: "${payload?.productDetailId}"
                productItemId:"${payload?.productItemId}"
                key: "${payload?.key}",
                invoiceId: "${payload?.invoiceId}",
                damagedCount: ${payload?.damagedCount},
                soldCount: ${payload?.soldCount},
                returnedToVendorCount: ${payload?.returnedToVendorCount},
                isRTV: ${payload?.isRTV},
                scrapCount: ${payload?.scrapCount}
            })
        }
        `;
        return query;
    } catch (ex) {
    }
}

const getMultipleInventoryCountsQuery = (payload: any) => {
    try {
        let query = `
        query {
            getMultipleInventoryCounts(
                productDetailId: "${payload?.productDetailId}"
            )
        }
        `;
        return query;
    } catch (ex) {
    }
}

const getMultipleInventorySoldListQuery = (payload: any) => {
    try {
        let query = `
        query {
            getMultipleInventory_soldList
            (
                productId: "${payload?.productId}"
            )
        }
        `;
        return query;
    } catch (ex) {
    }
}

const getMultipleInventoryDamagedListQuery = (payload: any) => {
    try {
        let query = `
        query {
            getMultipleInventory_damagedList
                (
                    productId: "${payload?.productId}"
                )
        }
        `;
        return query;
    } catch (ex) {
    }
}

const createOrUpdateCycleCountQuery = (payload: any) => {
    try {

        let query = `
        mutation{
            createOrUpdateCycleCount(input: {
                cycleCountJobId: "${payload?.cycleCountJobId}"
                name: "${payload?.name}"
                statusRefId : ${payload.statusRefId}
            })
            {
                cycleCountJobId
                name
                statusRefId
                isActive
            }
        }
        `;
        return query;
    } catch (ex) {
    }
}
const getCycleCountListQuery = (payload: any) => {
    try {
        let query = `
        query{
            getCycleCountList(input:{           
             searchText:"${payload?.searchText}"          
             paging:{
                limit:${payload?.limit}            
                offset:${payload?.offset}
             }            
            })         
            {         
             page{         
            nextPage         
             prevPage       
             totalCount
             currentPage
             }            
             cycleCountList{
             cycleCountJobId
             name
             cycleCountId
             statusRefId            
             status         
             createdBy
             createdOn
             isCompleted
                }
            }   
        }
        `;
        return query;
    } catch (ex) {
    }
}

const getMultipleSubcategoryListQuery = (payload: any) => {
    try {
        let query = `
            query{
                getCategorySubcategoryList(input: {
                    cycleCountJobId:"${payload?.cycleCountJobId}"
                    statusRefId: ${payload?.statusRefId}
                    isMultipleRecords: ${payload?.isMultipleRecords}
                    searchText: "${payload?.searchText}"
                    isCompleteStatus: ${payload?.isCompleteStatus}
                })
            }
        `;
        return query;
    } catch (ex) {
    }
}

const getProductListCategoryQuery = (payload: any) => {
    try {
        let query = `
        query{
            getProductListByCategorySubCategory(input: {
                categoryAndSubCategoryMappingId: "${payload?.categoryAndSubCategoryMappingId}"
                cycleCountJobId:  "${payload?.cycleCountJobId}"
                isMultipleRecords:${payload?.isMultipleRecords}
                isCycleCompleted : ${payload?.isCycleCompleted}
                type: "${payload?.type}"
            })
            }
        `;
        return query

    } catch (ex) {
    }
}

const getupdateCycleCountProductQuery = (payload: any) => {
    try {
        let query = `
        mutation{
            createOrUpdateCycleCountJobDetails(input:{
                cycleCountJobDetailId: "${payload?.cycleCountJobDetailId}"
                cycleCountJobId: "${payload?.cycleCountJobId}"     
                categoryAndSubCategoryMappingId: "${payload?.categoryAndSubCategoryMappingId}"           
                productItemId:"${payload?.productItemId}"           
                statusRefId: ${payload?.statusRefId}            
                availableCount: ${payload?.availableCount}         
                missingCount: ${payload?.missingCount}
            
            })
        }
        `;
        return query
    } catch (ex) {
    }
}

const updateCycleCountListQuery = (payload: any) => {
    try {
        let query = `
        mutation{
            updateCycleCountJobDetailStatus(input:{
                cycleCountJobId:"${payload?.cycleCountJobId}"
                categoryAndSubCategoryMappingId:"${payload?.categoryAndSubCategoryMappingId}"
                statusRefId:${payload?.statusRefId}
            })
        }
        `;
        return query
    } catch (ex) {

    }
}

const getMultipleScrapListQuery = (payload: any) => {
    try {
        let query = `
        query {
            getMultiple_inventoryScrapList(
                productId: "${payload?.productId}"
            )
        }
        `;
        return query
    } catch (ex) {

    }
}

const getCycleCountReportListQuery = (payload: any) => {
    try {
        let query = `
        query{
            getcycleCountReportList(
                cycleCountId: "${payload?.cycleCountJobId}"      
            )         
        }
        `;
        return query
    } catch (ex) {

    }
}

const getReportListQuery = (payload: any) => {
    try {
        let query = `
        query{
            getReportList(input: {
                month: "${payload?.month}"
                year: "${payload?.year}",
                fromDate: "${payload?.fromDate}",
                toDate: "${payload?.toDate}", 
                paging: {
                    limit: ${payload?.paging?.limit},
                    offset: ${payload?.paging?.offset}
                }   
            })         
        }
        `
        return query;
    } catch (error) {

    }
}

const getVendorListQuery = (payload: any) => {
    try {
        let query = `
        query{
            getVenderList(input: {
                searchText: "${payload?.searchText}"
                sortBy: ${payload?.sortBy},
                isActive: ${payload?.isActive != null ? payload.isActive : null},
                hasOutstandingDebt: ${payload?.hasOutstandingDebt ? true : null},
                paging: {
                    limit: ${payload?.paging?.limit},
                    offset: ${payload?.paging?.offset}
                }
            })
        }
        `
        return query;
    } catch (error) {

    }
}

const createOrUpdateVendorQuery = (payload: any) => {
    try {
        let query = `
        mutation{
            createOrUpdateVendor(input: {
                vendorId: "${payload?.vendorId}"
                name:  ${payload?.name ? `"${payload?.name}"` : null}
                description: ${payload?.description ? `"""${payload?.description}"""` : null}
                emailId : ${payload?.emailId ? `"${payload?.emailId}"` : null}
                mobileNumber : ${payload?.mobileNumber ? `"${payload?.mobileNumber}"` : null}
                websiteUrl: ${payload?.websiteUrl ? `"${payload?.websiteUrl}"` : null}
                contactName:  ${payload?.contactName ? `"${payload?.contactName}"` : null}
                streetArea:  ${payload?.streetArea ? `"${payload?.streetArea}"` : null}
                city:  ${payload?.city ? `"${payload?.city}"` : null}
                zipcode:  ${payload?.zipcode ? `"${payload?.zipcode}"` : null}
                stateRefId:  ${payload?.stateRefId ? `${payload?.stateRefId}` : null}   
                isActive:${payload?.isActive}
                isDeleted: ${payload?.isDeleted}
            })
            }
        `
        return query;
    } catch (error) {

    }
}

const getVenderEmailValidationQuery = (payload: any) => {
    try {
        let query = `
        query{
            getVenderEmailValidation(input: {
                vendorId: ${payload?.vendorId ? `"${payload?.vendorId}"` : null}, 
                emailId: "${payload?.emailId}"
            })
        }
        `
        return query;
    } catch (error) {

    }
}

const getVenderDropDownListQuery = () => {
    try {
        let query = `
            query {
                getVendorDropDownList
            }
        `
        return query;
    } catch (error) {

    }
}

const getVendorPurchaseListQuery = (payload: any) => {
    try {
        let query = `
        query{
            getVendorPurchaseList(input: {
                vendorId: ${payload?.vendorId ? `"${payload.vendorId}"` : null}
                fromDate: ${payload?.fromDate ? `"${payload.fromDate}"` : null}
                toDate: ${payload?.toDate ? `"${payload.toDate}"` : null}
                sortBy: ${payload?.sortBy},
                vendorPurchaseId: ${payload?.vendorPurchaseId ? `"${payload.vendorPurchaseId}"` : null}
                paging: {
                    limit: ${payload?.paging?.limit},
                    offset: ${payload?.paging?.offset}
                }
            })
        }
        `
        return query;
    } catch (error) {

    }
}

const createOrUpdateVendorPurchaseQuery = (payload: any) => {
    try {
        let query = `
        mutation{
            createOrUpdateVendorPurchase(input: {
                vendorPurchaseId: ${payload?.vendorPurchaseId ? `"${payload?.vendorPurchaseId}"` : null}
                vendorId: "${payload?.vendorId}"
                purchaseDate: "${payload?.purchaseDate}"
                gpayAmount: ${payload?.gpayAmount ?? 0}
                cashAmount: ${payload?.cashAmount ?? 0}
                shippingCharges: ${payload?.shippingCharges ?? 0}
                isDeleted: ${payload?.isDeleted ? 1 : 0}
            })
        }
        `
        return query;
    } catch (error) {

    }
}

const getRentalListQuery = (payload: any) => {
    try {
        let query = `
        query{
            getRentalList(input: {
                storeId: ${payload?.storeId ? Number(payload.storeId) : null}
                floor: ${payload?.floor ? `"${payload.floor}"` : null}
                rentMonth: ${payload?.rentMonth ? Number(payload.rentMonth) : null}
                fromDate: ${payload?.fromDate ? `"${payload.fromDate}"` : null}
                toDate: ${payload?.toDate ? `"${payload.toDate}"` : null}
                seekRentalId: ${payload?.seekRentalId ? `"${payload.seekRentalId}"` : null}
                paging: {
                    limit: ${payload?.paging?.limit},
                    offset: ${payload?.paging?.offset}
                }
            })
        }
        `
        return query;
    } catch (error) {

    }
}

const createOrUpdateRentalQuery = (payload: any) => {
    try {
        const remarks = payload?.remarks
            ? String(payload.remarks).replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\r?\n/g, "\\n")
            : "";
        let query = `
        mutation{
            createOrUpdateRental(input: {
                rentalId: ${payload?.rentalId ? `"${payload.rentalId}"` : null}
                storeId: ${payload?.storeId ? Number(payload.storeId) : null}
                floor: ${payload?.floor ? `"${payload.floor}"` : null}
                rentMonth: ${payload?.rentMonth ? Number(payload.rentMonth) : null}
                financialYear: ${payload?.financialYear ? Number(payload.financialYear) : null}
                paymentDate: ${payload?.paymentDate ? `"${payload.paymentDate}"` : null}
                amount: ${Number(payload?.amount) || 0}
                attachmentFileUuid: ${payload?.attachmentFileUuid ? `"${payload.attachmentFileUuid}"` : null}
                remarks: "${remarks}"
                isDeleted: ${payload?.isDeleted ? 1 : 0}
            })
        }
        `
        return query;
    } catch (error) {

    }
}

const getVendorPurchaseHistoryQuery = (payload: any) => {
    try {
        let query = `
        query {
            getVendorPurchaseHistory(input: {
                vendorId: "${payload?.vendorId}"
            })
        }
        `;
        return query;
    } catch (ex) {
    }
}

// Queries in this file are built by raw string interpolation, so any free
// text the user typed has to be neutralised before it goes in. A GraphQL
// block string ("""...""") tolerates quotes and newlines; the only sequence
// it cannot contain is a triple quote, so that is what gets stripped.
const toBlockString = (value: any) => {
    if (value === null || value === undefined || String(value).trim() === "") return null;
    return `"""${String(value).replace(/"""/g, '\\"\\"\\"')}"""`;
}

const getVendorDebtLedgerQuery = (payload: any) => {
    try {
        let query = `
        query {
            getVendorDebtLedger(input: {
                vendorId: "${payload?.vendorId || ''}",
                entryType: ${payload?.entryType ? `"${payload?.entryType}"` : null},
                fromDate: ${payload?.fromDate ? `"${payload?.fromDate}"` : null},
                toDate: ${payload?.toDate ? `"${payload?.toDate}"` : null},
                vendorDebtId: ${payload?.vendorDebtId ? `"${payload?.vendorDebtId}"` : null},
                paging: {
                    limit: ${payload?.limit ?? 10},
                    offset: ${payload?.offset ?? 0}
                }
            })
        }
        `;
        return query;
    } catch (ex) {
    }
}

const createVendorDebtEntryQuery = (payload: any) => {
    try {
        let query = `
        mutation {
            createVendorDebtEntry(input: {
                vendorId: "${payload?.vendorId || ''}",
                entryType: "${payload?.entryType}",
                amount: ${Number(payload?.amount) || 0},
                transactionDate: "${payload?.transactionDate}",
                notes: ${toBlockString(payload?.notes)}
            })
        }
        `;
        return query;
    } catch (ex) {
    }
}

const getMrpListQuery = () => {
    try {
        let query = `
            query {
                getMrpList
            }
        `
        return query;
    } catch (error) {

    }
}

const getEmployeeListQuery = (payload: any) => {
    try {
        let query = `
            query {
                getEmployeeList(input: {
                    searchText: "${payload?.searchText || ''}"
                    sortBy: ${payload?.sortBy || 4}
                    paging: { limit: ${payload?.paging?.limit || 10}, offset: ${payload?.paging?.offset || 0} }
                })
            }
        `
        return query;
    } catch (error) {

    }
}

const createOrUpdateEmployeeQuery = (payload: any) => {
    try {
        let query = `
            mutation {
                createOrUpdateEmployee(input: {
                    employeeId: "${payload?.employeeId || ''}"
                    name: ${payload?.name ? `"${payload?.name}"` : null}
                    mobileNumber: ${payload?.mobileNumber ? `"${payload?.mobileNumber}"` : null}
                    isActive: ${payload?.isActive ?? 1}
                    isDeleted: ${payload?.isDeleted ?? 0}
                    workTypeRefId: ${payload?.workTypeRefId ?? null}
                    allowedLeaveDays: ${payload?.allowedLeaveDays ?? null}
                })
            }
        `
        return query;
    } catch (error) {

    }
}

// Employee Attendance module — mirrors getCycleCountListQuery's paging shape.
// Contract matches the backend plan's viewAttendanceListInput / getAttendanceListData.
const getAttendanceListQuery = (payload: any) => {
    try {
        let query = `
        query{
            getAttendanceList(input:{
             searchText:"${payload?.searchText || ''}"
             month:${payload?.month}
             year:${payload?.year}
             paging:{
                limit:${payload?.limit}
                offset:${payload?.offset}
             }
            })
            {
             page{
             nextPage
             prevPage
             totalCount
             currentPage
             }
             attendanceList{
             employeeId
             employeeCode
             employeeName
             workType
             allowedLeaveDays
             actualWorkingHours
             expectedWorkingHrs
             actualLeaveTaken
             lop
             employeeDeletedAt
                }
            }
        }
        `;
        return query;
    } catch (ex) {
    }
}

const getEmployeeAttendanceCalendarQuery = (payload: any) => {
    try {
        let query = `
        query{
            getEmployeeAttendanceCalendar(input:{
                employeeId: "${payload?.employeeId}"
                month: ${payload?.month}
                year: ${payload?.year}
            })
            {
                attendanceDate
                statusRefId
                status
                workingHours
                loginTime
                lunchInTime
                lunchOutTime
                logoutTime
            }
        }
        `;
        return query;
    } catch (ex) {
    }
}

const getEmployeeAttendanceSummaryQuery = (payload: any) => {
    try {
        let query = `
        query{
            getEmployeeAttendanceSummary(input:{
                employeeId: "${payload?.employeeId}"
                month: ${payload?.month}
                year: ${payload?.year}
            })
            {
                employeeId
                employeeName
                workType
                allowedLeaveDays
                actualWorkingHours
                expectedWorkingHrs
                actualLeaveTaken
                lop
                employeeDeletedAt
            }
        }
        `;
        return query;
    } catch (ex) {
    }
}

const getAttendanceRecordByIdQuery = (payload: any) => {
    try {
        let query = `
        query{
            getAttendanceRecordById(recordId: "${payload?.recordId}")
            {
                employeeId
                employeeName
                attendanceDate
            }
        }
        `;
        return query;
    } catch (ex) {
    }
}

const markAttendanceQuery = (payload: any) => {
    try {
        const days = (payload?.days || []).map((d: any) => `{
                attendanceDate: "${d?.attendanceDate}"
                statusRefId: ${d?.statusRefId}
                workingHours: ${d?.workingHours ?? 0}
                loginTime: ${d?.loginTime ? `"${d.loginTime}"` : null}
                lunchInTime: ${d?.lunchInTime ? `"${d.lunchInTime}"` : null}
                lunchOutTime: ${d?.lunchOutTime ? `"${d.lunchOutTime}"` : null}
                logoutTime: ${d?.logoutTime ? `"${d.logoutTime}"` : null}
                remarks: "${d?.remarks || ''}"
            }`).join(",");
        let query = `
        mutation{
            markAttendance(input:{
                employeeId: "${payload?.employeeId}"
                days: [${days}]
            })
        }
        `;
        return query;
    } catch (ex) {
    }
}

const getEmployeeDropDownListQuery = () => {
    try {
        let query = `
            query {
                getEmployeeDropDownList
            }
        `
        return query;
    } catch (error) {

    }
}

const createOrUpdateProcurementQuery = (payload: any) => {

    try {
        let query = `
            mutation {
                createOrUpdateProcurement(input:{
                    procurementId : "${payload?.procurementId}"
                    categoryId :"${payload?.categoryId}"
                    subCategoryId :"${payload?.subCategoryId}"
                    status:${payload?.status}
                    count :${payload?.count}
                    description : "${payload?.description == undefined ? "" : payload?.description}"
                    imageFileUuid: ${payload?.imageFileUuid ? `"${payload.imageFileUuid}"` : null}
                    isDeleted: ${payload?.isDeleted}
                })
            }
        `
        return query;
    } catch (error) {

    }
}

const getProcurementExportListQuery = () => {
    try {
        let query = `
            query {
                getProcurementExportList
            }
        `
        return query;
    } catch (error) {

    }
}

const getAuditLogListQuery = (payload: any) => {
    try {
        let query = `
            query {
                getAuditLogList(input:{
                    moduleNames: ${payload?.moduleNames?.length ? `[${payload.moduleNames.map((m: string) => `"${m}"`).join(",")}]` : null}
                    operation: ${payload?.operation ? `"${payload.operation}"` : null}
                    fromDate: ${payload?.fromDate ? `"${payload.fromDate}"` : null}
                    toDate: ${payload?.toDate ? `"${payload.toDate}"` : null}
                    searchText: ${payload?.searchText ? `"${payload.searchText}"` : null}
                    paging: {
                        limit: ${payload?.paging?.limit},
                        offset: ${payload?.paging?.offset}
                    }
                })
            }
        `
        return query;
    } catch (error) {

    }
}

const getProcurementQuery = (payload: any) => {
    console.log("payloadQuery", payload);
    try {
        let query = `
            query {
                getProcurementList(input:{
                  searchText:"${payload?.searchText}",
                  sort:${payload?.sortBy}
                  categoryId:${payload?.categoryId ? `"${payload.categoryId}"` : null}
                  subCategoryId:${payload?.subCategoryId ? `"${payload.subCategoryId}"` : null}
                  procurementId:${payload?.procurementId ? `"${payload.procurementId}"` : null}
                  paging:{
                        limit:${payload?.paging?.limit},
                        offset:${payload?.paging?.offset}
                  }
                })
            }
        `
        return query;
    } catch (error) {

    }
}

const creatOrUpdateAttachmentQuery = (payload: any) => {
    let attachmentValue = JSON.stringify(payload?.attachment)
    let attachmentValues = attachmentValue.replace(/"([^(")"]+)":/g, "$1:")
    try {
        let query = `
        mutation{
            createOrUpdateAttachment(input: {
                attachment: ${attachmentValues}
            })
        }
        `
        return query;
    } catch (error) {
        console.log("Error in creatOrUpdateAttachmentQuery", error);
    }
}
const getSalesReturnQuery = (payload: any) => {
    try {
        let query = `
        query{
            getSalesReturnList(input:{
                searchText:"${payload?.searchText}"
                ${payload?.statusRefId ? `statusRefId:${payload.statusRefId}` : ``}
                ${payload?.hasCreditPayment === true ? `hasCreditPayment:true` : payload?.hasCreditPayment === false ? `hasCreditPayment:false` : ``}
                paging:{
                    limit:${payload?.limit}
                    offset:${payload?.offset}
                }
            })
        }`
        return query;
    } catch (error) {
        console.log("Error in getSalesReturnQuery", error);
    }
}

const getAttachmentQuery = (paylaod: any) => {
    try {
        let query = `
        query{
            getAttachement(input:{
                entityId: "${paylaod?.entityId}"
            })
        }
        `
        return query;
    } catch (error) {
        console.log("Error in getAttachmentQuery", error);
    }
}

const getVendorBillAttachmentQuery = (paylaod: any) => {
    try {
        let query = `
        query{
            getVendorBillAttachment(input:{
                entityId: "${paylaod?.entityId}"
            })
        }
        `
        return query;
    } catch (error) {
        console.log("Error in getVendorBillAttachmentQuery", error);
    }
}

const getVendorDebtAttachmentQuery = (paylaod: any) => {
    try {
        let query = `
        query{
            getVendorDebtAttachment(input:{
                entityId: "${paylaod?.entityId}"
            })
        }
        `
        return query;
    } catch (error) {
        console.log("Error in getVendorDebtAttachmentQuery", error);
    }
}

const createOrUpdateSalesReturnQuery = (payload: any) => {
    try {
        let query = `
        mutation{
            createOrUpdateSalesReturn(input:{
                salesReturnId:"${payload?.salesReturnId}"
                productItemId:"${payload?.productItemId}"
                invoiceId :"${payload?.invoiceId}"
                categoryId:"${payload?.categoryId}"
                subCategoryId:"${payload?.subCategoryId}"
                qty:${payload?.qty}
                returnedAmount:${payload?.returnedAmount}
                mrp:${payload?.mrp}
                isDeleted:${payload?.isDeleted}
                isMultipleRecords:${payload?.isMultipleRecords}
                status:"${payload?.status}"
                statusRefId:${payload?.statusRefId}
            })
        }`
        return query;
    } catch (error) {
        console.log("Error in createOrUpdateSalesReturnQuery", error);
    }
}

const getSalesReturnBasedOnProductIdQuery = (payload: any) => {
    try {
        let query = `
        query{
            getAddSalesReturnList(input:{
                productId:"${payload?.productId}"
                isEdit:${payload?.isEdit}
            })
        }
        `
        return query;
    } catch (error) {
        console.log("Error in getSalesReturnBasedOnProductIdQuery", error);
    }
}

const getSalesReturnBillDetailsQuery = (payload: any) => {
    try {
        let query = `
        query{
            getSalesReturnBillDetails(invoiceId: "${payload?.invoiceId}")
        }
        `
        return query;
    } catch (error) {
        console.log("Error in getSalesReturnBillDetailsQuery", error);
    }
}

const addCategoryQuery = (payload: any) => {
    const attachmentArr = JSON.stringify(payload?.attachment);
    const attachment = attachmentArr.replace(/"([^(")"]+)":/g, "$1:");

    try {
        let query = `
        mutation{
            createOrUpdateCategoryList(input: {
            categoryId: "${payload?.categoryId}",
            categoryName: "${payload?.categoryName}",
            description: ${payload?.description ? `"""${payload?.description}"""` : null},
            isActive: ${payload?.isActive},
            isDeleted: ${payload?.isDeleted},
            attachment:${attachment}
        })
        }
    `
        return query;
    } catch (error) {
        console.log("Error in addCategoryQuery", error);
    }

}

const createOrUpdateBannerQuery = (payload: any) => {
    try {
        let attachmentValue = JSON.stringify(payload?.attachment)
        let attachmentValues = attachmentValue.replace(/"([^(")"]+)":/g, "$1:")
        let query = `
        mutation{
        createOrUpdateBanner(input: {
            attachment:${attachmentValues}
        })
    }
    `
        return query;
    } catch (error) {
        console.log("Error in addCategoryQuery", error);
    }

}

const getMetaBannerQuery = (payload: any) => {
    try {
        let query = `
        query{
            getBannerMeta
        }
        `
        return query;
    } catch (error) {
        console.log("Error in getMetaBannerQuery", error);
    }
}

const getBannerAttachmentQuery = (payload: any) => {
    let query = `
        query{
            getBannerAttachment(
            entityId: ${payload?.entityId}
            )
        }
    `
    return query;
}

const addSubCategoryQuery = (payload: any) => {
    const attachmentArr = JSON.stringify(payload?.attachment);
    const attachment = attachmentArr.replace(/"([^(")"]+)":/g, "$1:");

    try {
        let query = `
        mutation{
            createOrUpdateSubCategoryList(input: {
            categoryId: "${payload?.categoryId}",
            subCategoryId: "${payload?.subCategoryId}",
            subCategoryName: "${payload?.subCategoryName}",
            displayRank: ${payload?.displayRank},
            description: ${payload?.description ? `"""${payload?.description}"""` : null},
            isActive: ${payload?.isActive},
            isDeleted: ${payload?.isDeleted},
            attachment:${attachment}
            })
        }`
        return query
    } catch (error) {
        console.log("Error in addSubCategoryQuery", error);
    }
}

const getHotNewTopPickQuery = (payload: any) => {
    try {
        let query = `
        query{
            getHotPicksAndTopNewAdmin(input: {
            searchText: "${payload?.searchText}",
            hotNewSort: ${payload?.hotNewSort},
            topPickSort: ${payload?.topPickSort},
                paging: {
                    limit: ${payload?.paging?.limit},
                    offset: ${payload?.paging?.offset}
                }
            })
        }
        `
        return query;
    } catch (error) {
        console.log("Error in getHotNewTopPickQuery", error);
    }
}

const createOrUpdateHotNewTopPickQuery = (payload: any) => {
    try {
        let query = `
        mutation{
        createOrUpdateHotNewTopPick(input: {
            productDetailId: "${payload?.productDetailId}",
            productItemId :"${payload?.productItemId}"
            hotNew: ${payload?.hotNew},
            topPick: ${payload?.topPick}
    })
}
        `
        return query;
    } catch (error) {
        console.log("Error in createOrUpdateHotNewTopPickQuery", error);
    }
}


const getOnlineOrderQuery = (payload: any) => {
    let query = `
    query {
        getOnlineOrders(input: {
        searchText: "${payload?.searchText}",
        sort: ${payload?.sort},
        paymentStatus: ${payload?.paymentStatus},
        paging: {
            limit: ${payload.paging.limit}
            offset: ${payload.paging.offset}
        }
    })
    }
    `
    return query;
}

const updateOrdersQuery = (payload: any) => {
    let query = `
        mutation{
    updateOrders(input: {
        orderId: "${payload?.orderId}",
        orderStatus: ${payload?.orderStatus}
    })
}
    `
    return query;
}

const getCoreCategoryMetaQuery = (payload: any) => {
    let query = `
        query{
            getCoreCategoryMeta
        }
    `
    return query;
}

// One combined query for the whole Reports > Dashboard screen — every widget's
// data comes back in a single round trip instead of one request per widget.
const getDashboardDataQuery = (payload: any) => {
    try {
        let fromDate = payload?.fromDate ?? "";
        let toDate = payload?.toDate ?? "";
        let query = `
        query{
            getDashboardSummary(input: { fromDate: "${fromDate}", toDate: "${toDate}" })
            getSalesTrend(input: { fromDate: "${fromDate}", toDate: "${toDate}" })
            getSalesByCategory(input: { fromDate: "${fromDate}", toDate: "${toDate}" })
            getCategoryStockDistribution
            getTopProducts(input: { fromDate: "${fromDate}", toDate: "${toDate}", limit: 500 })
            getTopCustomers(input: { fromDate: "${fromDate}", toDate: "${toDate}", limit: 500 })
            getRecentBills(input: { limit: 500 })
            getLowStockItems(input: { limit: 500 })
            getDeadStock(input: { limit: 500 })
            getOverstockItems(input: { limit: 500 })
            getRecentProducts(input: { limit: 500 })
            getRecentSuppliers(input: { limit: 500 })
            getCustomerGrowth(input: { fromDate: "${fromDate}", toDate: "${toDate}" })
        }
        `
        return query;
    } catch (error) {

    }
}

const getTopProductsQuery = (payload: any) => {
    try {
        let fromDate = payload?.fromDate ?? "";
        let toDate = payload?.toDate ?? "";
        let sortBy = payload?.sortBy ?? "revenue";
        let sortDir = payload?.sortDir ?? "desc";
        let query = `
        query{
            getTopProducts(input: { fromDate: "${fromDate}", toDate: "${toDate}", limit: 500, sortBy: "${sortBy}", sortDir: "${sortDir}" })
        }
        `
        return query;
    } catch (error) {

    }
}

const getTopCustomersQuery = (payload: any) => {
    try {
        let fromDate = payload?.fromDate ?? "";
        let toDate = payload?.toDate ?? "";
        let sortBy = payload?.sortBy ?? "totalSpend";
        let sortDir = payload?.sortDir ?? "desc";
        let query = `
        query{
            getTopCustomers(input: { fromDate: "${fromDate}", toDate: "${toDate}", limit: 500, sortBy: "${sortBy}", sortDir: "${sortDir}" })
        }
        `
        return query;
    } catch (error) {

    }
}

// One combined query for the Sales Dashboard screen — mirrors getDashboardDataQuery's
// "bundle every widget into one round trip" convention.
const getSalesDashboardDataQuery = (payload: any) => {
    try {
        let fromDate = payload?.fromDate ?? "";
        let toDate = payload?.toDate ?? "";
        let offset = payload?.offset ?? 0;
        let query = `
        query{
            getSalesSummary(input: { fromDate: "${fromDate}", toDate: "${toDate}" })
            getSalesTrend(input: { fromDate: "${fromDate}", toDate: "${toDate}" })
            getSalesByFinancialYear
            getSalesMonthComparison
            getSalesByCategory(input: { fromDate: "${fromDate}", toDate: "${toDate}" })
            getSalesBySubCategory(input: { fromDate: "${fromDate}", toDate: "${toDate}" })
            getSalesByPaymentMethod(input: { fromDate: "${fromDate}", toDate: "${toDate}" })
            getSalesByEmployee(input: { fromDate: "${fromDate}", toDate: "${toDate}" })
            getTopProducts(input: { fromDate: "${fromDate}", toDate: "${toDate}", limit: 10 })
            getSalesRecentBills(input: { limit: 10, offset: ${offset} })
            getPurchaseVsSalesByVendor(input: { fromDate: "${fromDate}", toDate: "${toDate}", limit: 200 })
        }
        `
        return query;
    } catch (error) {

    }
}

// One combined query for the Inventory Dashboard screen.
const getInventoryDashboardDataQuery = (payload: any) => {
    try {
        let fromDate = payload?.fromDate ?? "";
        let toDate = payload?.toDate ?? "";
        let query = `
        query{
            getInventorySummary
            getCategoryStockDistribution
            getTopMovingProducts(input: { fromDate: "${fromDate}", toDate: "${toDate}", limit: 20 })
            getSlowMovingProducts(input: { fromDate: "${fromDate}", toDate: "${toDate}", limit: 20 })
            getLowStockItems(input: { limit: 500 })
            getDeadStock(input: { limit: 500 })
            getOverstockItems(input: { limit: 500 })
            getNegativeStockItems(input: { limit: 500 })
            getRecentProducts(input: { limit: 500 })
            getRecentStockAdjustments(input: { limit: 500 })
            getPendingPurchaseOrders(input: { limit: 500 })
        }
        `
        return query;
    } catch (error) {

    }
}

// One combined query for the Customer Dashboard screen.
const getCustomerDashboardDataQuery = (payload: any) => {
    try {
        let fromDate = payload?.fromDate ?? "";
        let toDate = payload?.toDate ?? "";
        let query = `
        query{
            getCustomerSummary(input: { fromDate: "${fromDate}", toDate: "${toDate}" })
            getCustomerGrowth(input: { fromDate: "${fromDate}", toDate: "${toDate}" })
            getRepeatVsNewCustomers(input: { fromDate: "${fromDate}", toDate: "${toDate}" })
            getTopCustomers(input: { fromDate: "${fromDate}", toDate: "${toDate}", limit: 500 })
            getRecentCustomers(input: { limit: 500 })
            getInactiveCustomers(input: { limit: 500 })
        }
        `
        return query;
    } catch (error) {

    }
}

// Vendor Dashboard — vendor/purchase-only insights, bundled into ONE combined
// GraphQL round trip like the other dashboards. vendorId (vendor's uniqueKey)
// is optional and scopes the amount-based widgets to a single vendor when the
// dashboard's vendor filter is set.
const getVendorDashboardDataQuery = (payload: any) => {
    try {
        let vendorId = payload?.vendorId ?? "";
        let fromDate = payload?.fromDate ?? "";
        let toDate = payload?.toDate ?? "";
        let offset = payload?.offset ?? 0;
        let query = `
        query{
            getVendorSummary(input: { vendorId: "${vendorId}", fromDate: "${fromDate}", toDate: "${toDate}" })
            getPurchaseAmountByVendor(input: { vendorId: "${vendorId}", fromDate: "${fromDate}", toDate: "${toDate}" })
            getRecentVendorPurchases(input: { vendorId: "${vendorId}", fromDate: "${fromDate}", toDate: "${toDate}", limit: 1000, offset: ${offset} })
            getPurchaseVsSalesByVendor(input: { vendorId: "${vendorId}", fromDate: "${fromDate}", toDate: "${toDate}", limit: 200 })
            getPurchaseVsSalesTrend(input: { vendorId: "${vendorId}", fromDate: "${fromDate}", toDate: "${toDate}" })
        }
        `
        return query;
    } catch (error) {

    }
}

// Customer Credit Dashboard / Vendor Debt Dashboard — org-wide aggregates
// across ALL customers/vendors, each backed by a single dashboard-only
// backend query (getCustomerCreditDashboard/getVendorDebtDashboard) that
// already returns one combined JSON blob, so no bundling of sibling fields
// is needed here (unlike getVendorDashboardDataQuery above).
const getCustomerCreditDashboardDataQuery = (payload: any) => {
    try {
        let fromDate = payload?.fromDate ?? "";
        let toDate = payload?.toDate ?? "";
        let limit = payload?.limit ?? 10;
        let offset = payload?.offset ?? 0;
        let recentLimit = payload?.recentLimit ?? 10;
        let recentOffset = payload?.recentOffset ?? 0;
        let query = `
        query{
            getCustomerCreditDashboard(input: { fromDate: "${fromDate}", toDate: "${toDate}", limit: ${limit}, offset: ${offset}, recentLimit: ${recentLimit}, recentOffset: ${recentOffset} })
        }
        `
        return query;
    } catch (error) {

    }
}

const getVendorDebtDashboardDataQuery = (payload: any) => {
    try {
        let vendorId = payload?.vendorId ?? "";
        let entryType = payload?.entryType ?? "";
        let granularity = payload?.granularity ?? "month";
        let fromDate = payload?.fromDate ?? "";
        let toDate = payload?.toDate ?? "";
        let limit = payload?.limit ?? 10;
        let offset = payload?.offset ?? 0;
        let recentLimit = payload?.recentLimit ?? 10;
        let recentOffset = payload?.recentOffset ?? 0;
        let query = `
        query{
            getVendorDebtDashboard(input: { vendorId: "${vendorId}", entryType: "${entryType}", fromDate: "${fromDate}", toDate: "${toDate}", granularity: "${granularity}", limit: ${limit}, offset: ${offset}, recentLimit: ${recentLimit}, recentOffset: ${recentOffset} })
        }
        `
        return query;
    } catch (error) {

    }
}

// Employee Dashboard — mirrors the Vendor Dashboard pattern: one combined
// round trip, an optional employeeId filter that scopes the summary/table
// (but NOT the Sales by Employee chart, same precedent as Vendor
// Dashboard's Purchase-Amount-by-Vendor chart staying unfiltered), plus
// getSalesByEmployee — an existing query already used by the plain
// Dashboard screen — reused here as-is rather than duplicated.
const getEmployeeDashboardDataQuery = (payload: any) => {
    try {
        let employeeId = payload?.employeeId ?? "";
        let fromDate = payload?.fromDate ?? "";
        let toDate = payload?.toDate ?? "";
        let offset = payload?.offset ?? 0;
        let query = `
        query{
            getEmployeeSummary(input: { employeeId: "${employeeId}", fromDate: "${fromDate}", toDate: "${toDate}" })
            getSalesByEmployee(input: { fromDate: "${fromDate}", toDate: "${toDate}" })
            getAttendanceDistribution(input: { employeeId: "${employeeId}", fromDate: "${fromDate}", toDate: "${toDate}" })
            getEmployeePerformance(input: { employeeId: "${employeeId}", fromDate: "${fromDate}", toDate: "${toDate}", limit: 10, offset: ${offset} })
        }
        `
        return query;
    } catch (error) {

    }
}

// Custom Dashboard — every widget shares the exact same fromDate/toDate window
// (defaulted to today when blank), bundled into ONE combined GraphQL round trip
// like the other four dashboards.
const getCustomDashboardDataQuery = (payload: any) => {
    try {
        let fromDate = payload?.fromDate ?? "";
        let toDate = payload?.toDate ?? "";
        let sortBy = payload?.sortBy ?? "quantity";
        let customerSortBy = payload?.customerSortBy ?? "sales";
        let categoryIds: string[] = Array.isArray(payload?.categoryId) ? payload.categoryId : payload?.categoryId ? [payload.categoryId] : [];
        let subCategoryIds: string[] = Array.isArray(payload?.subCategoryId) ? payload.subCategoryId : payload?.subCategoryId ? [payload.subCategoryId] : [];
        let toGqlList = (ids: string[]) => `[${ids.map((id) => `"${id}"`).join(", ")}]`;
        let productFilter = `, categoryId: ${toGqlList(categoryIds)}, subCategoryId: ${toGqlList(subCategoryIds)}`;
        let query = `
        query{
            getCustomDashboardSummary(input: { fromDate: "${fromDate}", toDate: "${toDate}" ${productFilter} })
            getCustomSalesTrend(input: { fromDate: "${fromDate}", toDate: "${toDate}" ${productFilter} })
            getCustomSalesByCategory(input: { fromDate: "${fromDate}", toDate: "${toDate}" ${productFilter} })
            getCustomSalesBySubCategory(input: { fromDate: "${fromDate}", toDate: "${toDate}" ${productFilter} })
            getCustomCustomerGrowth(input: { fromDate: "${fromDate}", toDate: "${toDate}" ${productFilter} })
            getCustomPaymentMethodDistribution(input: { fromDate: "${fromDate}", toDate: "${toDate}" ${productFilter} })
            getCustomSalesByEmployee(input: { fromDate: "${fromDate}", toDate: "${toDate}" ${productFilter} })
            getCustomTopSellingProducts(input: { fromDate: "${fromDate}", toDate: "${toDate}", limit: 1000, sortBy: "${sortBy}" ${productFilter} })
            getCustomNewCustomers(input: { fromDate: "${fromDate}", toDate: "${toDate}" ${productFilter} })
            getCustomTopCustomers(input: { fromDate: "${fromDate}", toDate: "${toDate}", limit: 1000, customerSortBy: "${customerSortBy}" ${productFilter} })
            getCustomRepeatVsNewCustomers(input: { fromDate: "${fromDate}", toDate: "${toDate}" ${productFilter} })
            getCustomSalesReturn(input: { fromDate: "${fromDate}", toDate: "${toDate}" ${productFilter} })
        }
        `
        return query;
    } catch (error) {

    }
}

// Stock table → Stock History: one product's full movement history (stockMovement).
const getStockMovementHistoryQuery = (payload: any) => {
    try {
        let filters: string[] = [`productDetailId: "${payload?.productDetailId}"`];
        if (payload?.action) filters.push(`action: "${payload.action}"`);
        if (payload?.fromDate) filters.push(`fromDate: "${payload.fromDate}"`);
        if (payload?.toDate) filters.push(`toDate: "${payload.toDate}"`);
        filters.push(`limit: ${payload?.limit ?? 20}`);
        filters.push(`offset: ${payload?.offset ?? 0}`);
        return `
        query{
            getStockMovementHistory(input: { ${filters.join(", ")} })
        }
        `;
    } catch (error) {

    }
}

// Stock History screen — recent stock movement feed (admin manual add/remove for now).
const getStockHistoryQuery = (payload: any) => {
    try {
        let filters: string[] = [];
        if (payload?.productDetailId) filters.push(`productDetailId: "${payload.productDetailId}"`);
        if (payload?.searchText) filters.push(`searchText: "${payload.searchText}"`);
        if (payload?.operationType) filters.push(`operationType: "${payload.operationType}"`);
        if (payload?.fromDate) filters.push(`fromDate: "${payload.fromDate}"`);
        if (payload?.toDate) filters.push(`toDate: "${payload.toDate}"`);
        filters.push(`limit: ${payload?.limit ?? 20}`);
        filters.push(`offset: ${payload?.offset ?? 0}`);
        let query = `
        query{
            getStockHistory(input: { ${filters.join(", ")} })
        }
        `;
        return query;
    } catch (error) {

    }
}

// Combo stock — Add Stock's component picker: Regular bulk-count stock with
// something available, searched server-side (first page only, see
// ComboItemsSection).
const getComboComponentOptionsQuery = (payload: any) => {
    try {
        let query = `
        query{
            getComboComponentOptions(input: {
                searchText: ${JSON.stringify(String(payload?.searchText ?? ""))}
                paging: { limit: ${payload?.limit ?? 20}, offset: ${payload?.offset ?? 0} }
            })
        }
        `;
        return query;
    } catch (error) {

    }
}

// Combo stock — a combo's component lines for the read-only Edit view.
const getComboItemsQuery = (payload: any) => {
    try {
        let query = `
        query{
            getComboItems(productDetailId: "${payload?.productDetailId}")
        }
        `;
        return query;
    } catch (error) {

    }
}

const adminAdjustStockQuery = (payload: any) => {
    try {
        let query = `
        mutation{
            adminAdjustStock(input: {
                productDetailId: "${payload?.productDetailId}"
                operationType: "${payload?.operationType}"
                quantity: ${payload?.quantity}
                remarks: "${payload?.remarks ?? ""}"
            })
        }
        `;
        return query;
    } catch (error) {

    }
}

// Feedback Dashboard (Reports > Dashboards > Feedback) — one combined query,
// proxied by apparel-api's getFeedbackSummary resolver to the standalone
// feedback service. storeLocationId/purchaseChannel double as both the
// "All Stores"/"All Channels" dashboard filters. storeLocationId is that
// service's own KioskLocation UUID (from getFeedbackLocationsQuery below).
const getFeedbackDashboardDataQuery = (payload: any) => {
    try {
        let storeLocationId = payload?.storeLocationId ?? "";
        let purchaseChannel = payload?.purchaseChannel ?? "";
        let query = `
        query{
            getFeedbackSummary(input: { storeLocationId: "${storeLocationId}", purchaseChannel: "${purchaseChannel}" })
        }
        `
        return query;
    } catch (error) {

    }
}

// Feedback module — Browse Feedback list/view screen. search is escaped since
// it's free text the user types (customer name / mobile / comments). from/to
// are inclusive ISO date bounds on createdAt.
const getFeedbackListQuery = (payload: any) => {
    try {
        let page = payload?.page ?? 1;
        let pageSize = payload?.pageSize ?? 20;
        let from = payload?.from ?? "";
        let to = payload?.to ?? "";
        let storeLocationId = payload?.storeLocationId ?? "";
        let purchaseChannel = payload?.purchaseChannel ?? "";
        let language = payload?.language ?? "";
        let search = (payload?.search ?? "").replace(/"/g, '\\"');
        let customerDetailId = payload?.customerDetailId ?? "";
        let query = `
        query{
            getFeedbackList(input: { page: ${page}, pageSize: ${pageSize}, from: "${from}", to: "${to}", storeLocationId: "${storeLocationId}", purchaseChannel: "${purchaseChannel}", language: "${language}", search: "${search}", customerDetailId: "${customerDetailId}" })
        }
        `
        return query;
    } catch (error) {

    }
}

// Feedback module — Store filter dropdown source. No input; the feedback
// service's GET /kiosk-locations returns all locations (admin manages
// active/inactive there).
const getFeedbackLocationsQuery = () => {
    try {
        let query = `
        query{
            getFeedbackLocations
        }
        `
        return query;
    } catch (error) {

    }
}

export {
    getListQuery,
    createCustomerQuery,
    mergeCustomerQuery,
    setCustomerCreditLimitQuery,
    addCustomerCreditOpeningBalanceQuery,
    recordCustomerCreditSettlementQuery,
    getCustomerCreditLedgerQuery,
    updateProductItemColorOrSizeQuery,
    addProductQuery,
    getCategoryQuery,
    updateProductStatusQuery,
    updateStickeringStatusQuery,
    getProductListQuery,
    getCustomerListQuery,
    getReferenceDataQuery,
    getUpcomingCustomerEventsQuery,
    getProductItemQuery,
    createBillQuery,
    createBillQuery_V2,
    getBillingListQuery,
    apparelLoginQuery,
    sendLoginOtpQuery,
    verifyLoginOtpQuery,
    getCustomerHistoryQuery,
    getEmployeeSalesHistoryQuery,
    getProductHistoryQuery,
    getInvoiceDetailsQuery,
    updateMultipleInventoryQuery,
    getMultipleInventoryCountsQuery,
    getMultipleInventorySoldListQuery,
    getMultipleInventoryDamagedListQuery,
    createOrUpdateCycleCountQuery,
    getCycleCountListQuery,
    getMultipleSubcategoryListQuery,
    getProductListCategoryQuery,
    getupdateCycleCountProductQuery,
    updateCycleCountListQuery,
    getMultipleScrapListQuery,
    getCycleCountReportListQuery,
    getReportListQuery,
    getVendorListQuery,
    createOrUpdateVendorQuery,
    getVenderEmailValidationQuery,
    getVenderDropDownListQuery,
    getVendorPurchaseListQuery,
    getRentalListQuery,
    createOrUpdateRentalQuery,
    createOrUpdateVendorPurchaseQuery,
    getVendorPurchaseHistoryQuery,
    getVendorDebtLedgerQuery,
    createVendorDebtEntryQuery,
    getMrpListQuery,
    getEmployeeListQuery,
    createOrUpdateEmployeeQuery,
    getEmployeeDropDownListQuery,
    getAttendanceListQuery,
    getEmployeeAttendanceCalendarQuery,
    getEmployeeAttendanceSummaryQuery,
    getAttendanceRecordByIdQuery,
    markAttendanceQuery,
    createOrUpdateProcurementQuery,
    getProcurementExportListQuery,
    getAuditLogListQuery,
    creatOrUpdateAttachmentQuery,
    getAttachmentQuery,
    getVendorBillAttachmentQuery,
    getVendorDebtAttachmentQuery,
    getProcurementQuery,
    getSalesReturnQuery,
    createOrUpdateSalesReturnQuery,
    getSalesReturnBasedOnProductIdQuery,
    getSalesReturnBillDetailsQuery,
    addCategoryQuery,
    createOrUpdateBannerQuery,
    getMetaBannerQuery,
    getBannerAttachmentQuery,
    addSubCategoryQuery,
    getHotNewTopPickQuery,
    createOrUpdateHotNewTopPickQuery,
    getOnlineOrderQuery,
    updateOrdersQuery,
    getCoreCategoryMetaQuery,
    getDashboardDataQuery,
    getTopProductsQuery,
    getTopCustomersQuery,
    getSalesDashboardDataQuery,
    getInventoryDashboardDataQuery,
    getFeedbackDashboardDataQuery,
    getFeedbackListQuery,
    getFeedbackLocationsQuery,
    getCustomerDashboardDataQuery,
    getVendorDashboardDataQuery,
    getCustomerCreditDashboardDataQuery,
    getVendorDebtDashboardDataQuery,
    getEmployeeDashboardDataQuery,
    getCustomDashboardDataQuery,
    getStockHistoryQuery,
    getStockMovementHistoryQuery,
    adminAdjustStockQuery,
    getComboComponentOptionsQuery,
    getComboItemsQuery
}
